import React from 'react';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LogoPlaceholder from '../LogoPlaceHolder';
import { Promoter } from '../../types/promoter';


interface TitleTourProps {
  title: string;
  promoter: Promoter;
}

const TitleTour: React.FC<TitleTourProps> = ({ title, promoter }) => {
  return (
    <div className="title__tour">
      <div className='title__tour-datapromotor'>
        <h2>{title}</h2>
        <div className='promotor'>
          <div>
            {promoter.pictureURL && !promoter.pictureURL.includes('null') ? <img className="propotor__img" src={promoter.pictureURL} alt={promoter.fullname} /> : <LogoPlaceholder name={promoter.fullname} />}
          </div>
          <div className='promotor__box-data'>
            <p className="promotor__name">{promoter.fullname}</p>
            <a className="tour__link" href={promoter.viewMoreURL} target='_blank' rel="noopener noreferrer">
              Ver más
              <span><FontAwesomeIcon icon={faArrowRight} /></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TitleTour; 